module.exports = __webpack_public_path__ + "img/broccoli.4c2a635b.png";